import React from 'react';
import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { L2DPLogoIcon } from '@europrocurement/l2d-modules';

const Accueil = function () {
    return (
        <Container>
            <Box sx={{ margin: '30px 200px 0px 200px' }}>
                <L2DPLogoIcon />
            </Box>
            <Typography variant="l2dh4">Reglement Legal2digital</Typography>
        </Container>
    );
};
export default Accueil;
